var _circle, _circle2, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddEntityLesson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125.001,
    cy: 125.001,
    r: 108.333,
    fill: "#BFCBFE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.417,
    cy: 125.417,
    r: 95.4167,
    fill: "#8199F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_524_26030)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 125.001,
    cy: 125.001,
    r: 83.3333,
    fill: "#3855CA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.929 93C99.2388 93 93 98.459 93 105.188V145.812C93 152.541 99.2388 158 106.929 158H148.714H153.357C155.925 158 158 156.185 158 153.938C158 151.69 155.925 149.875 153.357 149.875V141.75C155.925 141.75 158 139.935 158 137.688V97.0625C158 94.8154 155.925 93 153.357 93H148.714H106.929ZM106.929 141.75H144.071V149.875H106.929C104.36 149.875 102.286 148.06 102.286 145.812C102.286 143.565 104.36 141.75 106.929 141.75ZM111.571 111.281C111.571 110.164 112.616 109.25 113.893 109.25H141.75C143.027 109.25 144.071 110.164 144.071 111.281C144.071 112.398 143.027 113.312 141.75 113.312H113.893C112.616 113.312 111.571 112.398 111.571 111.281ZM113.893 117.375H141.75C143.027 117.375 144.071 118.289 144.071 119.406C144.071 120.523 143.027 121.438 141.75 121.438H113.893C112.616 121.438 111.571 120.523 111.571 119.406C111.571 118.289 112.616 117.375 113.893 117.375Z",
    fill: "#A5B6FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_524_26030",
    x: 41.668,
    y: 41.668,
    width: 166.668,
    height: 170.668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_524_26030"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddEntityLesson);
export default __webpack_public_path__ + "static/media/add-entity-lesson.acadbea62204cb3efda54ab723cc66e6.svg";
export { ForwardRef as ReactComponent };